import {
  GET_MASTER_REPORTING_ITEMS,
  GET_MASTER_REPORTING_ITEMS_SUCCESS,
  GET_MASTER_REPORTING_ITEMS_FAILURE,
} from "./actionType";

//Get List of Master Reporting Items
export const getMasterReportingItems = () => ({
  type: GET_MASTER_REPORTING_ITEMS,
});
export const getMasterReportingItemsSuccess = (data) => ({
  type: GET_MASTER_REPORTING_ITEMS_SUCCESS,
  payload: data,
});
export const getMasterReportingItemsFailure = () => ({
  type: GET_MASTER_REPORTING_ITEMS_FAILURE,
});
